import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ColorModule } from '../color/color.module';

import { BoxInfoHeaderDirective, BoxInfoContentDirective, BoxInfoFooterDirective } from './box-info.directive';
import { BoxInfoComponent } from './box-info.component';
export class BoxInfoModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ColorModule],
    exports: [BoxInfoComponent, BoxInfoHeaderDirective, BoxInfoContentDirective, BoxInfoFooterDirective],
    declarations: [BoxInfoComponent, BoxInfoHeaderDirective, BoxInfoContentDirective, BoxInfoFooterDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxInfoModule_tsickle_Closure_declarations() {
/** @type {?} */
BoxInfoModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxInfoModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
